import styled from '@emotion/styled';

const Styled = styled.div(
  ({ theme }) => `

`,
);

export default Styled;
